import React from "react";

const UnAuthorized = () => {
    return(
        <div>
             <h1>Unauthorized - You do not have permission to access this page.</h1>;
        </div>
    )
}

export default UnAuthorized;